<template>
	
	<v-dialog v-model="model" persistent width="500px" scrollable>
		<v-card>
			<v-card-title class="title">Create a new user</v-card-title>
			<v-divider></v-divider>
			
			<v-card-text>
				<p class="my-2 red--text" v-if="submitError == true">{{errorMessage}}</p>
				<p class="my-2 green--text" v-if="submitError == false">Success</p>
				<v-form ref="vForm">
					<v-text-field v-model="firstname" :rules="[formRules.required]" label="First name"></v-text-field>
					<v-text-field v-model="lastname" :rules="[formRules.required]" label="Last name"></v-text-field>
					<v-text-field v-model="email" :rules="[formRules.required, formRules.email]" label="Email"></v-text-field>
					<v-text-field v-model="employee_id" :rules="[formRules.required]" label="Employee ID"></v-text-field>
					<v-text-field v-model="username" :rules="[formRules.required]" label="Username"></v-text-field>
					<v-select v-model="role" :rules="[formRules.required]" :items="roles" item-text="name" item-value="id" label="Role"></v-select>
					<v-select v-model="department" :rules="[formRules.required]" :items="departments" item-text="name" item-value="name" label="Department"></v-select>

				</v-form>
			</v-card-text>
			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn flat color="secondary" @click="model = false">CLOSE</v-btn>
				<v-btn flat color="secondary" @click="submit">SUBMIT</v-btn>
			</v-card-actions>

		</v-card>
	</v-dialog>

</template>

<script>

import VueCookies from 'vue-cookies';
import axios from 'axios';

export default {

	created : function(){

		this.token = (VueCookies.get(this.cookieKey)).token;

		this.eventHub.$on("openCreateUserModal", () => {
			this.model = true;
			this.submitError = null;
			setTimeout(() => {
				this.firstname = null;
				this.lastname = null;
				this.username = null;
				this.email = null;
				this.department = null;
				this.employee_id = null;
			},300);
		});

		this.getRoles().then((response) => {
			this.roles = response.data.data;
			console.log(this.roles);
		});

		this.getDepartments().then((response) => {
			this.departments = response.data.data;
			console.log(this.departments);
		})

	},

	data : function(){
		return {
			token : '',
			model : false,
			roles : [],
			departments : [],
			firstname : null,
			lastname : null,
			department : null,
			employee_id : null,
			email : null,
			username : null,
			role : null,
			errorMessage : '',
			submitError : null
		}
	},

	methods : {

		submit : function(){
			if (this.$refs.vForm.validate()) {
				this.eventHub.$emit("openGlobalLoaderModal");

				this.createNewUser().then((response) => {
					if(response.data.status){
						this.$refs.vForm.reset();
						this.eventHub.$emit("newUserWereCreated");
						this.submitError = false;
					}else{
						this.errorMessage = response.data.message;
						this.submitError = true;
					}

					this.eventHub.$emit("closeGlobalLoaderModal");

				});
			}
		},

		getRoles : function(){

			return axios.create({
                baseURL : this.apiUrl,
                headers : {
                    'Authorization' : `Bearer ${this.token}`
                }
            })
            .get('/users/roles');

		},

		getDepartments : function(){

			return axios.create({
				baseURL : this.apiUrl,
				headers : {
					'Authorization' : `Bearer ${this.token}`
				}
			})
			.get('/users/departments');

		},

		createNewUser : function(){
			let formData = new FormData();

			formData.append("firstname", this.firstname);
			formData.append("lastname", this.lastname);
			formData.append("username", this.username);
			formData.append("email", this.email);
			formData.append("role_id", this.role);
			formData.append("department", this.department);
			formData.append("employee_id", this.employee_id);


			return axios.create({
                baseURL : this.apiUrl,
                headers : {
                    'Authorization' : `Bearer ${this.token}`
                }
            })
            .post('/users/create', formData);

		}
	}

};

</script>